import {Component, Input, OnInit} from '@angular/core';
import * as Validations from '../../../../shared/constants/validation.constants';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CommonService} from '../../../../shared/services/common.service';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../state/app.state';
import {DropdownOption} from '../../../../../models/dropdown-option.model';
import {AddMetricOptionRequest} from '../../core/clients-list.actions';

@Component({
  selector: 'app-add-metric-option',
  templateUrl: './add-metric-option.component.html',
  styleUrls: ['./add-metric-option.component.css']
})
export class AddMetricOptionComponent implements OnInit {
  @Input() data: any;
  validations = Validations;
  errorMessages: any = {};
  errorMessageMap = {
    name: {
      required: 'This field is required.',
      minlength: 'Minimum 2 characters required.',
      maxlength: 'Minimum 50 characters required.',
    },
    code: {},
    type: {},
    isActive: {},
  }

  typeOptions: DropdownOption[] = [
    {
      key: 1,
      value: 'Text'
    },
    {
      key: 2,
      value: 'Numeric'
    },
  ]

  statusOptions: DropdownOption[] = [
    {
      key: true,
      value: 'Active'
    },
    {
      key: false,
      value: 'Inactive'
    },
  ]

  form = new FormGroup<any>({
    name: new FormControl<string>('', [
      Validators.required,
      Validators.minLength(this.validations.measurements.name.length.min),
      Validators.maxLength(this.validations.measurements.name.length.max),
    ]),
    code: new FormControl<string>(''),
    type: new FormControl<number>(this.typeOptions[0].key as number),
    isActive: new FormControl<boolean>(this.statusOptions[0].key as boolean),
  })

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
  }

  ngOnInit() {
    this.form.controls['name'].valueChanges.subscribe((value) => {
      // const convert name to camel case
      let code = '';
      if (value) {
        code = this.commonService.camelCase(value, true);
      }
      this.form.controls['code'].patchValue(code);
    })
  }

  handleSubmit() {
    if (this.form.invalid) {
      this.errorMessages = this.commonService.checkFormValidation(this.form, this.errorMessageMap);
      return;
    }

    const payload = this.form.getRawValue();
    this.store.dispatch(AddMetricOptionRequest({
      payload: {
        ...payload,
        extras: this.data['extras'],
      }
    }))
  }

  handleCancel() {
    this.commonService.closeDialog();
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }
}
